import { Badge } from '@components'
import type { Setup } from '@here/api'
import { Show } from 'solid-js'
import { Flex } from 'styled-system/jsx'

export default function (props: { setup?: Setup }) {
	return (
		<Show when={props.setup}>
			<Flex
				marginTop="-32px"
				height="21px"
				zIndex={1}
				gap={2}
				px={2}
				justifyContent="space-between"
				alignItems="center"
			>
				<Badge
					bg="neutralSubtle"
					color="white"
					variant="solid"
					size="sm"
				>
					{props.setup?.stage}
				</Badge>
				<Badge
					bg="neutralSubtle"
					color="white"
					variant="solid"
					size="sm"
				>
					{props.setup?.risk_reward_ratio}
				</Badge>
			</Flex>
		</Show>
	)
}
